export default "__VITE_ASSET__BA7T7lWf__"